import { ImgHTMLAttributes, useRef, useState } from "react"

import clsx from "clsx"

/**
 * Image component for rendering images with optional priority loading and fade-in effect.
 *
 * @param {ImgHTMLAttributes<HTMLImageElement> & { priority?: boolean }} props - The props for the Image component.
 * @returns {JSX.Element} The rendered image.
 */
export function Image({
  src,
  alt,
  priority = false,
  className = "",
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & { priority?: boolean }) {
  const ref = useRef<HTMLImageElement>(null)
  const [isLoaded, setIsLoaded] = useState(priority || (ref.current?.complete ?? false))

  return (
    <>
      {/* TODO: Hoist to <head> */}
      {priority && <link rel="preload" as="image" href={src} />}
      <img
        ref={ref}
        loading={priority ? "eager" : "lazy"}
        src={src}
        alt={alt}
        {...props}
        onLoad={() => setIsLoaded(true)}
        className={clsx(className, "transition", !isLoaded && "opacity-0")}
      />
    </>
  )
}

export default Image
